__turbopack_context__.v({
  "container": "index-module__Ol6FXq__container",
  "dotTyping": "index-module__Ol6FXq__dotTyping",
});
